<template>
  <v-overlay :value="progress" color="primary">
    <v-progress-circular
      indeterminate
      size="64"
      color="accent"
    ></v-progress-circular>
  </v-overlay>
</template>
<script>
import EventBus from "@/config/bus";

export default {
  data() {
    return {
      progress: false,
      error: false
    };
  },
  mounted() {
    EventBus.$on("PROGRESS_SHOW", () => {
      this.progress = true;
      // :: Hide after 6 seconds, in case the request fails
      setTimeout(function() {
        this.hideProgress;
      }, 6000);
    });
    EventBus.$on("PROGRESS_HIDE", () => {
      this.progress = false;
    });
  },
  methods: {
    hideProgress() {
      EventBus.$emit("PROGRESS_HIDE");
      this.error = false;
    },
    reloadPage() {
      this.$router.go();
    }
  }
};
</script>
